<template>
  <div>
    <div v-if="project">
      <div
        data-ix="hide-fixed-top-wrapper"
        class="w-hidden-small w-hidden-tiny fixed-block-top-wrapper"
      >
        <div class="w-container container with-fixed-block">
          <div class="fixed-block-wrapper">
            <a
              href="#"
              data-ix="close-fixed-bar"
              class="w-inline-block fixed-block-close-button"
            >
              <img
                src="/images/Icon-close-thin.png"
                class="close-icon"
              >
            </a>
            <Sidebar />
          </div>
        </div>
      </div>
      <Navbar />
      <div
        class="w-section work-page-header"
        :style="backgroundImage(project.image)"
      >
        <div
          data-ix="navbar-grow"
          class="work-header-overlay"
        >
          <a
            href="#view-project"
            class="w-hidden-small w-hidden-tiny w-inline-block work-scroll-button"
          >
            <div class="mouse-icon-block">
              <div
                data-ix="mouse-scroll-icon"
                class="mouse-scroll-icon"
              />
            </div>
          </a>
          <div class="w-container container">
            <h1
              data-ix="fade-in-on-load-2"
              class="page-header-title"
            >
              {{ project.title }}
            </h1>
            <h1
              data-ix="fade-in-on-load-3"
              data-w-expand="service-category"
              class="page-header-title subtitle"
            >
              {{ project.subtitle }}
            </h1>
          </div>
        </div>
      </div>
      <div
        id="view-project"
        class="w-section section"
      >
        <div class="w-container container with-fixed-block">
          <div class="dynamic-item-wrapper">
            <div class="portfolio-images-block">
              <div class="w-row project-images-row">
                <div
                  v-for="(picture, index) in project.description_images"
                  :key="index"
                  class="w-col w-col-6 w-col-small-6 work-image-column"
                >
                  <img
                    class="project-image"
                    :src="loadImg(picture)"
                  >
                </div>
              </div>
            </div>
            <div class="dynamic-item-content-block work-info-block">
              <div class="work-block-title">
                Project description:
              </div>
              <div
                class="w-richtext"
                v-html="compiledMarkdown"
              >
                {{ compiledMarkdown }}
              </div>
            </div>
          </div>
          <div
            data-ix="show-fixed-block"
            class="fixed-block-container-wrapper"
          >
            <Sidebar />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Navbar from '@/components/TheNavbar'
import Sidebar from '@/components/TheSidebar'
// import Footer from '@/components/TheFooter'

export default {
  name: 'Project',

  components: {
    Navbar,
    Sidebar,
    // Footer,
  },

  props: {
    slug: {
      required: true,
      type: String,
    },
  },

  computed: {
    ...mapGetters(['getProjectBySlug']),
    project() {
      return this.getProjectBySlug(this.slug)
    },
    compiledMarkdown() {
      return this.getMardownFile(this.project.description)
    },
  },

  mounted() {
    this.fetchProjects().then(() => {})
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },

  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },

  methods: {
    ...mapActions(['fetchProjects']),
    getMardownFile(filename) {
      // eslint-disable-next-line
      return require(`../data/projects/${filename}`)
    },

    backgroundImage(filename) {
      return {
        // eslint-disable-next-line
        'background-image': `url('${this.loadImg(filename)}')`,
      }
    },

    loadImg(filename) {
      let photo
      if (this.project) {
        // eslint-disable-next-line
        photo = require(`../assets/project_photos/${filename}`)
      }
      return photo
    },
  },
}
</script>

<style>
.work-page-header {
  height: 100vh;
}
</style>
